const isBoolean = val => 'boolean' === typeof val;
const isNumber = val => /[0-9]/.test(val);

export default {
  isBoolean,
  isNumber
}